'use strict';

function scheduleSend(target, flush) {
    var delay;
    var treshold = 0;

    // First stop any timer in progress, we'll recreate one later if needed
    clearTimeout(target.sendTimeout);
    target.sendTimeout = null;

    // If we have nothing to send, don't bother
    if (target.msgQueue.length === 0) {
        return;

    // If flushing, do it now
    } else if (flush) {
        delay = 0;

    // If a request is in progress, re-evaluate time when it completes
    } else if (target.sendPromise) {
        return;

    // Backout slowly if we keep seeing errors
    } else if (target.sendErrors > 0) {
        delay = target.sendErrors * target.sendMaxInterval;

    // If we have a bunch of messages queued, send as fast as possible
    } else if (target.msgQueue.length >= target.sendLimitEntries) {
        delay = target.sendMinInterval;

    // or-else just send at a reasonable rate
    } else {
        delay = target.sendMaxInterval;

        // and attempt to send at once a log burst occuring after a period of calm
        treshold = target.sendMinInterval;
    }

    // Adjust delay by time already spent waiting since last log sent
    delay = Math.max(treshold, delay + target.lastSendAt - Date.now());

    if (delay === 0) {
        sendLogs(target, flush);
    } else {
        target.sendTimeout = setTimeout(sendLogs.bind(null, target, false), delay);
    }
}

function sendLogs(target, flush) {
    var entries = [];
    var logMsg;
    var promise;

    // Only create concurrent requests if we're being forced to
    if (target.sendPromise && !flush) return;

    while (target.msgQueue.length > 0 && (flush || entries.length < target.sendLimitEntries)) {
        entries.push(target.msgQueue.shift());
    }

    if (entries.length === 0) return;

    target.lastSendAt = Date.now();

    logMsg = target.logger.plugins.context.mergeContexts(
        target.remoteContext,
        target.logger.getFullNodeContext(),
        {entries: entries}
    );

    promise = target.sendPromise = fetch(target.loggingServer + '/log', {
        method: 'POST',
        mode: 'cors',
        // Send cookies since Logging Service seem to use those
        credentials: 'same-origin',
        cache: 'no-store',
        redirect: 'follow',
        headers: {
            'Content-Type': 'application/json'
        },
        /*
         It's acceptable to use JSON.stringify since this will use the same ordering as Object.keys
         See JO abstract operation from http://www.ecma-international.org/ecma-262/5.1/#sec-15.12.3
         Most (all?) modern engines enumerate in the property creation order.
         See https://esdiscuss.org/topic/nailing-object-property-order
         and https://esdiscuss.org/topic/property-ordering-of-enumerate-getownpropertynames
         */
        body: JSON.stringify(logMsg)
    }).then(function (response) {
        var error;

        if (response.ok) {
            return response;
        }

        error = new Error('Response not ok.');
        error.response = response;
        return response.text()
            .then(function (responseText) {
                error.responseText = responseText;
            }, function () {
                // Swallow the parsing error
            })
            .then(function () {
                return Promise.reject(error);
            });
    });

    promise.then(function (/* response */) {
        if (promise !== target.sendPromise) return;
        target.sendPromise = null;

        if (target.sendErrors > 0) {
            target.logger.signals.onError.dispatch({
                source: 'remote',
                type: 'resume',
                detail: {
                    sendErrors: target.sendErrors
                }
            });
            target.sendErrors = 0;
        }

        scheduleSend(target, false);
    },
    function (error) {
        // Put unsent messages back in the queue
        // TODO: Should logger root context be attached more permanently to entries for failed logs?
        Array.prototype.unshift.apply(target.msgQueue, entries);

        if (promise !== target.sendPromise) return;
        target.sendPromise = null;

        target.sendErrors++;

        // TODO: Handler error.response 'X-Rate-Limit-Limit' header if any

        // Log if first time error, after scheduling to avoid triggering send
        if (target.sendErrors === 1) {
            target.logger.signals.onError.dispatch({
                source: 'remote',
                type: 'error',
                detail: {
                    firstEntrySeqNum: entries[0].seqNum,
                    message: error.message,
                    serverStatus: error.response ? error.response.status : 0,
                    serverData: error.responseText
                }
            });
        } else {
            scheduleSend(target, false);
        }
    });
}

function onFormattedLog(event) {
    this.msgQueue.push(event.entry);
    scheduleSend(this, false);
}

function onFlush() {
    scheduleSend(this, true);
}

function LoggingServiceLogTarget(logger, config) {
    this.logger = logger;
    this.sendLimitEntries = 10;
    this.sendMaxInterval = 2000;
    this.sendMinInterval = 200;
    this.sendTimeout = null;
    this.sendPromise = null;
    this.lastSendAt = 0;
    this.sendErrors = 0;
    this.msgQueue = [];

    this.remoteContext = config.context;

    // loads environment specific config
    this.loggingServer = config.server;

    this.logger.signals.onFormattedLog.add(onFormattedLog, this);
    this.logger.signals.onFlush.add(onFlush, this);
}

function LoggerTargetLoggingServiceRootInit() {
    // eslint-disable-next-line no-new
    new LoggingServiceLogTarget(this, this.plugins.loggerTargetLoggingService.config);
}

function LoggerTargetLoggingServicePlugin(config) {
    return {
        pluginName: 'loggerTargetLoggingService',
        config: config,

        dependencies: ['context', 'logger'],

        rootInit: LoggerTargetLoggingServiceRootInit
    };
}

module.exports = LoggerTargetLoggingServicePlugin;



//////////////////
// WEBPACK FOOTER
// ./~/@getgo/logger-target-logging-service/lib/logger_target_logging_service.js
// module id = 723
// module chunks = 0